import { render, staticRenderFns } from "./KpiBoxesComponent.vue?vue&type=template&id=78e9529b"
import script from "./KpiBoxesComponent.vue?vue&type=script&lang=js"
export * from "./KpiBoxesComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports